import Actions from "../Types";

const initialState = {
    isSearching: false,
    searchStaffSuccess: false,
    error: null,
    searchedStaff: []
}

export default (state = initialState, action) => {
    switch(action.type){
        case Actions.SEARCH_STAFF_START:
            return{
                ...state,
                isSearching: true,
                error: null,
                searchStaffSuccess: false
            }
        case Actions.SEARCH_STAFF_SUCCESS:
            return{
                ...state,
                isSearching: false,
                error: null,
                searchedStaff: action.payload,
                searchStaffSuccess: true
            }
        case Actions.SEARCH_STAFF_FAILURE:
            return{
                ...state,
                isSearching: false,
                error: action.payload,
                searchStaffSuccess: false
            }
        default:
            return state;
    }
}